import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Bell, Trophy, Activity, User, Clock, Zap, Star, Flame, Award, Heart } from 'lucide-react';

const Home = () => {
const {userData} = useAuth();
const [gameModes, setGameModes] = useState([]);
const [selectedGameMode, setSelectedGameMode] = useState(null);
const [userResults, setUserResults] = useState([]);
const [leaderboard, setLeaderboard] = useState([]);
const [loading, setLoading] = useState({
  gameModes: true,
  userResults: true,
  leaderboard: true
});

// Fetch game modes data
useEffect(() => {
  // Simulating API fetch
  setTimeout(() => {
    const data = [
      {
        id: 1,
        icon: "boxing.png",
        title: "Power",
        description: "Reveal the power of your Punch, You have 3 Tries, Press the center after each Punch",
        backgroundColor: "#120239",
        coinsNeeded: 200,
        tokensNeeded: 300,
        turnsNumber: 3
      },
      {
        id: 2,
        icon: "endurance.png",
        title: "Endurance",
        description: "Keep your Performance up, and test your endurance Level, 45 secs to Hit the maximum number of powerful punches",
        backgroundColor: "#ff9d1a",
        coinsNeeded: 200, 
        tokensNeeded: 200,
        turnsNumber: 5
      },
      {
        id: 3,
        icon: "speed.png",
        title: "Speed",
        description: "30 secs of action, Maximum number of punches is the key of success",
        backgroundColor: "#f15a10",
        coinsNeeded: 50,
        tokensNeeded: 0,
        turnsNumber: 5
      },
      {
        id: 4,
        icon: "training.png",
        title: "Reflex",
        description: "Test your Reflex time and how speed you response, Hit on whistle",
        backgroundColor: "#350b06",
        coinsNeeded: 50,
        tokensNeeded: 0,
        turnsNumber: 8
      }
    ];
    setGameModes(data);
    setSelectedGameMode(data[0]);
    setLoading(prev => ({ ...prev, gameModes: false }));
  }, 1000);
}, []);

// Fetch user results when selected game mode changes
useEffect(() => {
  if (selectedGameMode) {
    setLoading(prev => ({ ...prev, userResults: true }));
    // Simulating API fetch
    setTimeout(() => {
      // Example API endpoint: /game-result/user-results/param=?userId=4&gameModeId=${selectedGameMode.id}&page=1&limit=10
      const data = {
        data: [
          {
            id: 28,
            gameModeId: 1,
            userId: "4",
            score: 35353,
            result: JSON.stringify({
              force: "3435",
              speed: "34",
              power: "35353",
              work: "535353",
              momentum: "23235",
              damage: "65857"
            }),
            createdAt: "2025-05-03T17:13:58.430Z"
          },
          {
            id: 27,
            gameModeId: 1,
            userId: "4",
            score: 645,
            result: JSON.stringify({
              force: "346",
              speed: "64",
              power: "645",
              work: "53",
              momentum: "53",
              damage: "3"
            }),
            createdAt: "2025-05-03T16:51:58.334Z"
          },
          {
            id: 22,
            gameModeId: 1,
            userId: "4",
            score: 42,
            result: JSON.stringify({
              force: "2342",
              speed: "42",
              power: "42",
              work: "553",
              momentum: "53535",
              damage: "5"
            }),
            createdAt: "2025-05-01T10:18:04.940Z"
          }
        ],
        total: selectedGameMode.id === 1 ? 4 : 0,
        totalPages: 1,
        currentPage: 1
      };
      
      // For demonstration, show empty state for other game modes
      if (selectedGameMode.id !== 1) {
        data.data = [];
        data.total = 0;
      }
        
      setUserResults(data);
      setLoading(prev => ({ ...prev, userResults: false }));
    }, 800);
  }
}, [selectedGameMode]);

// Fetch leaderboard data when selected game mode changes
useEffect(() => {
  if (selectedGameMode) {
    setLoading(prev => ({ ...prev, leaderboard: true }));
    // Simulating API fetch
    setTimeout(() => {
      // Example API endpoint: /game-result/top-ranking/param=?userId=4&gameModeId=${selectedGameMode.id}&page=1&limit=10
      let data = [];
      
      if (selectedGameMode.id === 1) {
        data = [
          {
            userId: "2",
            maxScore: 85858,
            users: {
              id: "2",
              user_name: "maher84",
              full_name: "maher"
            },
            countries: {
              id: 1,
              name: "Qatar",
              abbr: "QA"
            }
          },
          {
            userId: "4",
            maxScore: 35353,
            users: {
              id: "4",
              user_name: "OMRAN",
              full_name: "Iman"
            },
            countries: {
              id: 1,
              name: "Qatar",
              abbr: "QA"
            }
          },
          {
            userId: "2",
            maxScore: 3262,
            users: {
              id: "2",
              user_name: "maher84",
              full_name: "maher"
            },
            countries: {
              id: 1,
              name: "Qatar",
              abbr: "QA"
            }
          }
        ];
      }
      
      setLeaderboard(data);
      setLoading(prev => ({ ...prev, leaderboard: false }));
    }, 1200);
  }
}, [selectedGameMode]);

const handleGameModeSelect = (gameMode) => {
  setSelectedGameMode(gameMode);
};

// Format date to readable string
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    day: 'numeric', 
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format large numbers with commas
const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Get game mode icon component
const getGameModeIcon = (title) => {
  switch(title.toLowerCase()) {
    case 'power':
      return <Star className="w-8 h-8" />;
    case 'endurance':
      return <Heart className="w-8 h-8" />;
    case 'speed':
      return <Zap className="w-8 h-8" />;
    case 'reflex':
      return <Clock className="w-8 h-8" />;
    default:
      return <Activity className="w-8 h-8" />;
  }
};

return (
  <div className="min-h-screen bg-gray-100 text-gray-900">

    
    <main className="container mx-auto px-4 py-6 md:px-8">
      {/* Game Mode Highlights */}
      <section className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Game Modes</h2>
        </div>
        
        {loading.gameModes ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="bg-gray-200 animate-pulse rounded-xl h-40"></div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {gameModes.map((mode) => (
              <div 
                key={mode.id}
                className={`rounded-xl p-4 transition-all cursor-pointer hover:scale-105 ${selectedGameMode?.id === mode.id ? 'ring-4 ring-[#FF9200]' : ''}`}
                style={{ backgroundColor: mode.backgroundColor }}
                onClick={() => handleGameModeSelect(mode)}
              >
                <div className="text-white flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      {getGameModeIcon(mode.title)}
                      <h3 className="text-xl font-bold ml-2">{mode.title}</h3>
                    </div>
                    <p className="text-sm text-gray-200 mb-3 line-clamp-2">{mode.description}</p>
                    <div className="flex items-center text-xs space-x-2">
                      <span className="bg-white bg-opacity-20 rounded-full px-2 py-1">
                        {mode.coinsNeeded} coins
                      </span>
                      {mode.tokensNeeded > 0 && (
                        <span className="bg-white bg-opacity-20 rounded-full px-2 py-1">
                          {mode.tokensNeeded} tokens
                        </span>
                      )}
                      <span className="bg-white bg-opacity-20 rounded-full px-2 py-1">
                        {mode.turnsNumber} turns
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      
      {/* Selected Game Mode Details */}
      {selectedGameMode && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {/* Recent Activity */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-md p-4 h-full">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold flex items-center">
                  <Activity className="h-5 w-5 text-[#FF9200] mr-2" />
                  Recent Activity - {selectedGameMode.title}
                </h2>
              </div>
              
              {loading.userResults ? (
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-gray-100 animate-pulse rounded-lg h-20"></div>
                  ))}
                </div>
              ) : userResults.data && userResults.data.length > 0 ? (
                <div className="space-y-3">
                  {userResults.data.map((result) => {
                    const resultData = JSON.parse(result.result);
                    return (
                      <div key={result.id} className="bg-gray-50 rounded-lg p-3 hover:bg-gray-100 transition">
                        <div className="flex justify-between mb-2">
                          <div className="font-semibold text-lg">Score: {formatNumber(result.score)}</div>
                          <div className="text-sm text-gray-500">{formatDate(result.createdAt)}</div>
                        </div>
                        <div className="grid grid-cols-3 md:grid-cols-6 gap-2 text-sm">
                          <div className="bg-[#120239] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Force</div>
                            <div>{formatNumber(resultData.force)}</div>
                          </div>
                          <div className="bg-[#120239] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Speed</div>
                            <div>{formatNumber(resultData.speed)}</div>
                          </div>
                          <div className="bg-[#FF9200] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Power</div>
                            <div>{formatNumber(resultData.power)}</div>
                          </div>
                          <div className="bg-[#FF9200] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Work</div>
                            <div>{formatNumber(resultData.work)}</div>
                          </div>
                          <div className="bg-[#120239] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Momentum</div>
                            <div>{formatNumber(resultData.momentum)}</div>
                          </div>
                          <div className="bg-[#120239] bg-opacity-10 rounded p-1 text-center">
                            <div className="font-medium">Damage</div>
                            <div>{formatNumber(resultData.damage)}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-64 text-center">
                  <Flame className="h-16 w-16 text-gray-300 mb-4" />
                  <h3 className="text-xl font-semibold text-gray-600 mb-2">No Activity Yet</h3>
                  <p className="text-gray-500 mb-4">You haven't tried {selectedGameMode.title} mode yet!</p>
                  <button className="bg-[#FF9200] hover:bg-[#FF9200]/80 text-white font-bold py-2 px-6 rounded-full focus:outline-none focus:ring-2 focus:ring-[#FF9200] focus:ring-opacity-50 transition">
                    Start Playing
                  </button>
                </div>
              )}
            </div>
          </div>
          
          {/* Leaderboard */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-md p-4 h-full">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold flex items-center">
                  <Trophy className="h-5 w-5 text-[#FF9200] mr-2" />
                  Leaderboard
                </h2>
              </div>
              
              {loading.leaderboard ? (
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-gray-100 animate-pulse rounded-lg h-16"></div>
                  ))}
                </div>
              ) : leaderboard.length > 0 ? (
                <div className="space-y-2">
                  {leaderboard.map((entry, index) => (
                    <div key={index} className={`rounded-lg p-3 flex items-center ${
                      index === 0 ? 'bg-yellow-50 border border-yellow-200' : 
                      index === 1 ? 'bg-gray-50 border border-gray-200' : 
                      index === 2 ? 'bg-orange-50 border border-orange-200' : 'bg-gray-50'
                    }`}>
                      <div className={`rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold ${
                        index === 0 ? 'bg-yellow-400 text-white' : 
                        index === 1 ? 'bg-gray-400 text-white' : 
                        index === 2 ? 'bg-orange-600 text-white' : 'bg-gray-200'
                      }`}>
                        {index + 1}
                      </div>
                      <div className="flex-1">
                        <div className="font-medium">{entry.users.full_name}</div>
                        <div className="text-xs text-gray-500 flex items-center">
                          <span>{entry.countries.abbr}</span>
                          <span className="mx-1">•</span>
                          <span>@{entry.users.user_name}</span>
                        </div>
                      </div>
                      <div className="font-bold text-lg text-[#FF9200]">{formatNumber(entry.maxScore)}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-64 text-center">
                  <Trophy className="h-16 w-16 text-gray-300 mb-4" />
                  <h3 className="text-xl font-semibold text-gray-600 mb-2">No Rankings Yet</h3>
                  <p className="text-gray-500 mb-4">Be the first to compete in {selectedGameMode.title} mode!</p>
                  <button className="bg-[#120239] hover:bg-[#120239]/80 text-white font-bold py-2 px-6 rounded-full focus:outline-none focus:ring-2 focus:ring-[#120239] focus:ring-opacity-50 transition">
                    Compete Now
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      
      {/* Game Insights */}
      <section className="mb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-[#120239] text-white rounded-xl p-4 flex items-center">
            <div className="bg-white bg-opacity-20 rounded-full p-3 mr-4">
              <Flame className="h-8 w-8 text-[#FF9200]" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">Your Top Score</h3>
              <p className="text-2xl font-bold">35,353</p>
            </div>
          </div>
          
          <div className="bg-[#FF9200] text-white rounded-xl p-4 flex items-center">
            <div className="bg-white bg-opacity-20 rounded-full p-3 mr-4">
              <Activity className="h-8 w-8 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">Total Games</h3>
              <p className="text-2xl font-bold">12</p>
            </div>
          </div>
          
          <div className="bg-gray-800 text-white rounded-xl p-4 flex items-center">
            <div className="bg-white bg-opacity-20 rounded-full p-3 mr-4">
              <Trophy className="h-8 w-8 text-[#FF9200]" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">Global Rank</h3>
              <p className="text-2xl font-bold">#42</p>
            </div>
          </div>
        </div>
      </section>
    </main>
    

  </div>
);
};

export default Home;
